/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { ICoreContext } from '@msdyn365-commerce/core-internal';
import { ArrayExtensions } from '@msdyn365-commerce-modules/retail-actions';
import React from 'react';

import { ISwatchItem, SwatchComponent } from '../../product-dimension';

/**
 * Props for product component swatch.
 */
export interface IProductComponentSwatchProps {
    context: ICoreContext;
    swatches: ISwatchItem[];
    dimensionType?: string;
    onSelectDimension(coreContext: ICoreContext, swatchItem: ISwatchItem, dimensionType?: string): void;
}

/**
 * Swatch for the product component.
 * @param props - Swatch props.
 * @returns React element.
 */
export const ProductComponentSwatchComponent: React.FC<IProductComponentSwatchProps> = (props: IProductComponentSwatchProps) => {
    const { context, dimensionType, swatches, onSelectDimension } = props;

    const onSelectItem = React.useCallback((item: ISwatchItem) => {
        onSelectDimension(context, item, dimensionType);
    }, [onSelectDimension, context, dimensionType]);
    if (ArrayExtensions.hasElements(swatches)) {
        return (
            <SwatchComponent
                apiSettings={context.request.apiSettings}
                list={swatches}
                onSelectItem={onSelectItem}
            />
        );
    }

    return (
        <div className='msc-swatch-empty' />
    );
};
